import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'
import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import type { CosmicProductType } from '@/lib/cms/cosmic/types/CosmicProductType'

type Props = {
  hydraToken: string
}

export type Creator = {
  href: {
    href: string
  }
  humanName: {
    fullName: string
  }
  username?: string
}

export type Customer = {
  href: string
  id: {
    unicity: number
  }
  status: string
  type: string
}

export type HydraLines = {
  items: Array<HydraLinesItem>
}

export type HydraLinesItem = {
  productData?: CosmicProductType // Product data with variations taken from the CMS, this is not returned from the API, we inject it after.
  catalogSlide?: {
    content: {
      description: string
    }
  }
  item: {
    href: string
    id: {
      unicity: string
    }
  }
  quantity: number
  recurrence?: {
    dateNext: string
    dateStarts: string
    monthNext: number
    schedule: {
      dayOfMonth: number
      month: string
      dateStarts: string
    }
    status: string
  }
  terms?: {
    modificationDate: string
    priceEach: number
    pvEach: number
  }
}

export type Recurrence = {
  dateNext?: string
  dateStarts?: string
  lastOrderId?: number
  lastRunDate?: string
  monthNext?: number
  schedule: {
    dayOfMonth: string
    month: string
    dateStarts: string
  }
  status: string
}

export type Terms = {
  discount: {
    amount: number
  }
  freight: {
    amount: number
  }
  modificationDate: string
  pv: number
  subtotal: number
  tax: {
    amount: number
  }
  total: number
}
export type Transaction = {
  amount: number
  method: string
  methodDetails: {
    alias: string
    creditCardNumberMasked?: string
  }
  type: string
}
type Transactions = {
  items?: Array<Transaction>
}
export type HydraGetSubscriptionItem = {
  creator: Creator
  currency: string
  customer: Customer
  dateCreated: string
  href: string
  id: {
    exigo: number
    unicity: string
  }
  isStaged: boolean
  lines: HydraLines
  market: string
  modificationDate: string
  recurrence: Recurrence
  shipToAddress: {
    address1: string
    address2?: string
    city: string
    zip: string
    state?: string
    country: Alpha2CountryCode
  }
  shipToEmail: string
  shipToName: {
    firstName: string
    fullName?: string
    lastName: string
  }
  shipToPhone: string
  shippingMethod: {
    href: string
    type: string
    location: string
  }
  status: string
  terms: Terms
  transactions: Transactions
}

export type HydraGetSubscriptionsResponse = {
  items: HydraGetSubscriptionItem[]
}

export const HydraGetSubscriptions = ({ hydraToken }: Props) => {
  const request: SendRequestType = {
    method: 'GET',
    url: `/customers/me/autoorders`,
    token: hydraToken,
  }

  return httpTools.sendRequest<HydraGetSubscriptionsResponse>(request)
}
